/* DEVONA – final theme-only cleanup. Does not change catalog/product data. */
(() => {
  const applyTemplateClass = () => {
    const template = document.querySelector('main[data-template]')?.dataset.template;
    if (template) document.body.classList.add(`template-${template}`, 'devona-ready');
  };

  const addAltFallbacks = () => {
    const productTitle = document.querySelector('.devona-product-intro__title, .product__title h1')?.textContent?.trim();
    if (productTitle) {
      document.querySelectorAll('.product__media img, .thumbnail img').forEach((img) => {
        if (!img.getAttribute('alt')?.trim()) img.setAttribute('alt', productTitle);
      });
    }

    document.querySelectorAll('.card-wrapper').forEach((card) => {
      const title = card.querySelector('.card__heading')?.textContent?.trim();
      if (!title) return;
      card.querySelectorAll('img').forEach((img) => {
        if (!img.getAttribute('alt')?.trim()) img.setAttribute('alt', title);
      });
    });
  };

  const normalizePieceLabels = () => {
    document.querySelectorAll('.product-form__input').forEach((group) => {
      const label = group.querySelector('legend, .form__label')?.textContent?.trim().toLowerCase() || '';
      if (!label.includes('stück')) return;
      group.querySelectorAll('input[type="radio"] + label').forEach((choice) => {
        const raw = choice.textContent.trim();
        if (/^(1|5|10)$/.test(raw)) choice.textContent = `${raw} Stück`;
      });
    });
  };

  applyTemplateClass();
  document.addEventListener('DOMContentLoaded', () => {
    applyTemplateClass();
    addAltFallbacks();
    normalizePieceLabels();
  }, { once: true });
})();
